import { clientApi } from 'api';
import { ICatalogue } from 'server/models/Catalogue/types';

export const addHomeProduct = (isServer = false) => async (id: string) => {
  const response = await clientApi.post<ICatalogue>(`/home-products/${id}`);

  return response;
};
